import { createRouter, createWebHistory } from 'vue-router'
import { useAuthentication } from '@/hooks/auth'
import getAppRoutes from '@/router/appRoutes'
import getAuthRoutes from '@/router/authRoutes'
import AppLayout from '@/layout/AppLayout.vue'
import AuthLayout from '@/layout/AuthLayout.vue'
import { useAuthStore } from '@/stores/authStore.ts'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // authenticated user
    {
      path: '/',
      component: AppLayout,
      ...useAuthentication(),
      children: getAppRoutes()
    },
    // not authenticated user
    {
      path: '/auth',
      name: 'auth',
      component: AuthLayout,
      children: getAuthRoutes()
    }
  ]
})

router.beforeEach((to, from, next) => {
  const auth = useAuthStore()

  const isLoggedIn = auth.isAuthenticated()

  if (to.meta.requiresAuth && !isLoggedIn) {
    return next({ name: 'login' })
  }

  /*

  TODO

  const userRole = auth.userRole()

  if (to.meta.roles && !to.meta.roles.includes(userRole)) {
    return next({ name: 'access_denied' })
  }
   */

  return next()
})

export default router
